import { Action, Middleware } from "redux";
import { logEventAnalytics } from "../libs/amplitudeHelper";

interface AnalyticsAction extends Action {
  meta?: { doNotSendToAnalytics?: boolean };
  payload?: Record<string, unknown>;
}

const analyticsMiddleware: Middleware = (api) => (next) => (action) => {
  const a = action as AnalyticsAction;
  if (!(a.meta && a.meta.doNotSendToAnalytics)) {
    try {
      logEventAnalytics(
        a.type,
        a.payload
          ? {
              ...a.payload,
            }
          : null
      );
    } catch (error) {
      console.error("Analytics error", error);
    }
  }

  return next(action);
};

export default analyticsMiddleware;
